import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {CLIENT_CONFIG} from '../../../config/client-config.token';

@Injectable({
  providedIn: 'root'
})
export class AppLocaleInitializerService {

  private http: HttpClient = inject(HttpClient);
  private API_URL = inject(CLIENT_CONFIG).baseApiUrl;

  private _locale: string | undefined;
  private _currencyCode: string | undefined;

  async loadSettings(): Promise<void> {

    const url = `${this.API_URL}system/localization/`;
    try {
      const response = await (
        this.http.get<{ data: { locale: string, currency: string } }>(url).pipe(
          map(response => response.data),
        ).toPromise()
      );

      this._locale = response.locale;
      this._currencyCode = response.currency;
    } catch (error) {
      console.error('Failed to load locale from backend, using default.', error);
      this._locale = 'sl-SI';
      this._currencyCode = 'EUR';
    }
  }

  get locale(): string {
    return this._locale || 'sl-SI';
  }

  get currencyCode(): string {
    return this._currencyCode || 'EUR';
  }
}
